import { create } from 'zustand';
import type { ApiErrorCode } from '../api/client';

// ANX-105 — глобальное состояние paywall-апселла. Наполняется из ApiClient
// (onPaywall-хук на 402-paywall), читается PaywallDialog'ом в AppShell.
interface PaywallState {
  code: ApiErrorCode | null;
  open: (code: ApiErrorCode) => void;
  close: () => void;
}

export const usePaywallStore = create<PaywallState>((set) => ({
  code: null,
  open: (code) => set({ code }),
  close: () => set({ code: null }),
}));
